import {http, baseUrl} from "../config/Constantes";
import CRUDService from "./geral/CRUDService";

export default class TimesheetService extends CRUDService {
    constructor() {
        super("timesheet");
    }

    carregarTiposHora() {
        return http.get("/timesheet/tipo-hora")
    }

    getByTaskId(taskId) {
        return http.get("/timesheet/"+taskId);
    }

    getByTimesheet(timesheetId) {
        return http.get("/timesheet/horas-extras-lote/"+timesheetId)
    }

    tramitar(detalhes, outcome, comentario) {
        return http.post("/timesheet/tramitar", {detalhes: detalhes, outcome: outcome, comentario: comentario});
    }

    salvar(timesheet) {
        return http.post("/timesheet/salvar", timesheet);
    }

    tramitarEmLote(acoesTarefaBpm) {
        return http.post("/timesheet/tramitar/lote", acoesTarefaBpm)
    }

    downloadModeloPlanilha() {
        window.location.href = baseUrl + "/timesheet/download-modelo";
    }

    periodoEnvioTimesheetPermitido() {
        return http.post("/timesheet/verificacao-bloqueio")
    }

    listarTimesheets(filtro) {
        return http.post("/timesheet/listar-timesheets", filtro)
    }
    listarTimesheetsNaoGerados() {
        return http.get("/timesheet/listar-timesheets-nao-gerados")
    }
    reenviarTimesheet(id) {
        return http.post("/timesheet/"+id+"/recriar-alocacoes");
    }

    cancelarTimesheet(timesheet, observacao) {
        timesheet.timesheetObservacoes = observacao
        return http.post("/timesheet/"+timesheet.timesheetId+"/cancelar", timesheet);
    }

    liberarReprocessamento(id) {
        return http.post("/timesheet/"+id+"/liberar-reprocessamento");
    }
    
    //RHFPP-2370-PocTimesheet
    getByTaskIdV2(taskId) {
        //return http.get("/timesheet/"+taskId);
        return http.get("/timesheet/tarefa/"+taskId);
    }
    tramitarV2(detalhes, outcome, comentario) {
        //return http.post("/timesheet/tramitar", {detalhes: detalhes, outcome: outcome, comentario: comentario});
        return http.post("/timesheet/tarefa/tramitar", {detalhes: detalhes, outcome: outcome, comentario: comentario});
    }
    tramitarEmLoteV2(acoesTarefaBpm) {
        //return http.post("/timesheet/tramitar/lote", acoesTarefaBpm)
        return http.post("/timesheet/tarefa/tramitar/lote", acoesTarefaBpm)
    }

    getHistorico(idTimesheet){
        return http.get("/timesheet/historico/" + idTimesheet);
    }

}